<template>
    <div class="main-container box-page">
        <router-view></router-view>
        <!-- Navbar section -->
        <HeaderAppLanding />
        <div class="site-wrapper-box">
            <div class="site-wrapper">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title text-center section-space--mb_60">
                            <h2 class="font-weight--light mb-15">利用規約</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <p>page TODO: ここには、利用規約を書きます。</p>
                    <p>TODO: and English text.</p>
                    <p>formatted text, English and Japanese, shift by languages</p>
                    <p>a check box </p>
                    <p>OK button, with check confirm, no checked comfirm no activation</p>
                </div>
             </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'app',
        components: {
        },

        metaInfo: {
            title: 'CREIS Japan | ユーザ - 新規登録' ,
            htmlAttrs: {
                lang: 'jp',
                amp: true
            }
        }
    }
</script>